import React, { useEffect, useState } from 'react'

import InitLIFFScript from '../../components/liff/InitiLIFFScript'

const liffIds = {
    development: '1653826158-3OyByQNb',
    production: '1653872801-qGlrL3NG',
}

function useQuery() {
    const queryString = decodeURIComponent(window.location.search).replace('?liff.state=', '')
    return new URLSearchParams(queryString)
}

const LineUIDPage: React.FC = () => {
    const queries = useQuery()
    const [profile, setProfile] = useState<any>(null)

    const handleChangedEnv = (e: React.ChangeEvent<HTMLSelectElement>) => {
        const value = e.currentTarget.value || 'development'
        const url = new URL(window.location.href)
        const search_params = url.searchParams

        search_params.set('mode', value)
        url.search = search_params.toString()
        const newURL = url.toString()
        window.location.href = newURL
    }

    useEffect(() => {
        if (profile === null) {
            window.liff.ready.then(window.liff.getProfile).then(setProfile)
        }
    }, [profile])

    return (
        <InitLIFFScript liffId={liffIds[queries.get('mode') || '']}>
            <div className="abcs-container">
                <select onChange={handleChangedEnv} defaultValue={queries.get('mode') || ''}>
                    <option value="development">Development</option>
                    <option value="production">Production</option>
                </select>
                <div style={{ margin: '2rem 0', display: 'grid', rowGap: '1rem' }}>
                    <div>
                        <div style={{ fontWeight: 'bold', fontSize: '1.2rem' }}>
                            Your LINE user id{' '}
                        </div>
                        <div>{profile?.userId}</div>
                    </div>

                    <div>
                        <div style={{ fontWeight: 'bold', fontSize: '1.2rem' }}>Your name </div>
                        <div>{profile?.displayName}</div>
                    </div>

                    <div>
                        <div style={{ fontWeight: 'bold', fontSize: '1.2rem' }}>Your Profile</div>
                        <img
                            style={{ width: '128px', height: '128px' }}
                            src={profile?.pictureUrl}
                            alt="profile-picture"
                        />
                    </div>

                    <div>
                        <div style={{ fontWeight: 'bold', fontSize: '1.2rem' }}>
                            Your Status message
                        </div>
                        <div>{profile?.statusMessage}</div>
                    </div>
                </div>
            </div>
        </InitLIFFScript>
    )
}

export default LineUIDPage
